// @flow
import { takeEvery, put, call, select } from 'redux-saga/effects';
import type { ActionType } from 'redux-actions';
import {
  requestChannelStats,
  requestBrandEngageChannelStats,
  receiveChannelStats,
} from './channelStatsActions';
import {
  getChannelStats,
  getbrandEngageChannelsStats,
} from './channelStatsApi';
import { selectToken } from 'ducks/SagaUtils';
import { PWR_DISTRO_CLIENT_IDS } from 'config/pwrDistroClientIds';

const selectDistributionStatus = (state: *) => {
  const distributionStatus = state.distributionStatus;
  const clientId = state.clients && state.clients.currentClient;

  if (typeof distributionStatus === 'boolean') {
    return distributionStatus;
  }

  if (distributionStatus instanceof Error) {
    return clientId ? PWR_DISTRO_CLIENT_IDS.includes(clientId) : false;
  }

  return false;
};

function* fetchChannelStats(
  action: ActionType<typeof requestChannelStats>
): Generator<*, *, *> {
  const token = yield select(selectToken);
  const { clientId, channelName, worklist, channelType } = action.payload;

  const distributionStatus = yield select(selectDistributionStatus);
  const isPwrDistro =
    channelType === 'Review' || channelType === 'Question'
      ? distributionStatus
      : false;

  try {
    const response = yield call(
      getChannelStats,
      token,
      clientId,
      channelName,
      worklist,
      isPwrDistro
    );
    yield put(receiveChannelStats(response, action.payload));
  } catch (err) {
    yield put(receiveChannelStats(err, action.payload));
  }
}

function* fetchBrandEngageChannelStats(
  action: ActionType<typeof requestBrandEngageChannelStats>
): Generator<*, *, *> {
  const token = yield select(selectToken);
  const { clientId, channelName, brandEngageType } = action.payload;

  try {
    const response: string = yield call(
      getbrandEngageChannelsStats,
      token,
      brandEngageType,
      clientId,
      channelName
    );

    const count = {
      [channelName]: +response,
    };
    yield put(receiveChannelStats(count, action.payload));
  } catch (err) {
    yield put(receiveChannelStats(err, action.payload));
  }
}

export default function*(): Generator<*, *, *> {
  yield takeEvery(requestChannelStats, fetchChannelStats);
  yield takeEvery(requestBrandEngageChannelStats, fetchBrandEngageChannelStats);
}



// WEBPACK FOOTER //
// ./src/containers/channels/channelStatsSaga.js